import Link from "next/link";
import React, { useCallback, useState } from "react";
import { login } from "../../helper/sso";
import Image from "next/image";
import { ErrorText, FeedbackText } from "../shared/FeedbackText";
import Loading from "../ui/Loading";
import { AppContext } from "../../provider/AppContextProvider";

export type UserProps = {
  toggleRegister: Function;
  user: any;
  setUser: any;
  showCustomize: boolean;
};

export default function UserSignedOut(props: UserProps) {
  const { debugLog } = React.useContext(AppContext);
  
  const [isTryingLogin, setIsTryingLogin] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loginMessage, setLoginMessage] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const updateUser = useCallback(
    (updatedUser: any) => {
      props.setUser(updatedUser);
    },
    [props]
  );

  const clickLogin = useCallback(async () => {
    if (!userName || !password) {
      if (!userName) {
        setEmailError(true);
      } else {
        setEmailError(false);
      }
      if (!password) {
        setPasswordError(true);
      } else {
        setPasswordError(false);
      }
    } else {
      setIsTryingLogin(true);
      setEmailError(false);
      setPasswordError(false);
      const data = await login(userName, password);
      if (data.user) {
        setLoginMessage("");
        setIsTryingLogin(false);
        data.user.decoded = data.decoded;

        debugLog("user signed out login " + JSON.stringify(data.user));

        updateUser(data.user);
      } else {
        setIsTryingLogin(false);
        if (data.error) {
          setLoginMessage(data.error);
        }
      }
    }
  }, [userName, password, setLoginMessage, updateUser]);

  return (
    <React.Fragment>
      {!props.user && (
        <React.Fragment>
          <div className="user-login flex flex-col space-y-4 p-6 py-8">
            <h1 className="mb-4 text-center font-lato text-xl">Login</h1>
            <form className="form">
              {loginMessage && <FeedbackText role="alert">{loginMessage}</FeedbackText>}
              <div className="space-y-2">
                <div>
                  <input
                    onChange={(e) => {
                      setUserName(e.target.value);
                    }}
                    type="text"
                    placeholder="E-Mail"
                    aria-label="E-Mail"
                    {...(emailError && { 'aria-describedby': 'email-error' })}
                  />
                  {emailError && (
                    <ErrorText className="mt-1" id="email-error" role="alert">
                      Bitte geben Sie Ihre E-Mail-Adresse ein.
                    </ErrorText>
                  )}
                </div>
                <div>
                  <input
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        clickLogin();
                      }
                    }}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    type="password"
                    placeholder="Passwort"
                    aria-label="Passwort"
                    {...(passwordError && { 'aria-describedby': 'password-error' })}
                  />
                  {passwordError && (
                    <ErrorText className="mt-1" id="password-error" role="alert">
                      Bitte geben Sie Ihr Passwort ein.
                    </ErrorText>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between text-xs">
                <div>
                  <div>Einloggen zu Ihrem VNP-Account.</div>
                  <div>
                    <span>Kein Account? </span>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        props.toggleRegister();
                      }}
                      className="text-highlighted"
                    >
                      Jetzt registrieren!
                    </button>
                  </div>
                </div>
                <Image
                  src="/images/logo-vnp.png"
                  width="63"
                  height="32"
                  alt="Logo VNP"
                />
              </div>
              <div className="flex flex-col space-y-2 items-center justify-center">
                {false && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      clickLogin();
                    }}
                    className="btn btn-light"
                  >
                    Anmelden
                  </a>
                )}
                <button
                  type="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    clickLogin();
                  }}
                  className={`btn btn-light `}
                  disabled={isTryingLogin}
                >
                  {isTryingLogin && <Loading small={true} inline={true} />}
                  Anmelden
                </button>
                <a
                  className="text-highlighted text-xs p-2"
                  href={`${process.env.NEXT_PUBLIC_VNP_BASE_URL}/resetpassword`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Passwort vergessen?
                </a>
              </div>
            </form>
          </div>
          <div className="p-6 py-8 border-t border-border">
            <h2 className="font-lato text-lg">Noch nicht registriert?</h2>
            <p className="text-sm mb-4">
              Registrieren Sie sich jetzt und profitieren Sie von allen
              Vorteilen!
            </p>

            <button 
              type="button"
              onClick={(e) => {
                e.preventDefault();
                props.toggleRegister();
              }}
              className="btn btn-primary w-full"
            >
              {/* <a onClick={(e) => { e.preventDefault(); props.toggleRegister() }} className="btn btn-primary-dark w-full"> */}
              Jetzt registrieren
              {/* </a> */}
              </button>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
